import moment from 'moment';
import { get } from 'lodash';

export const prioritizeRules = function (ruleset) {
  const nonDefaultRules = ruleset.filter(({ description }) => !description.includes('default'));
  if (nonDefaultRules.length) {
    /**
     * If more than one rule (e.g. base rule + custom rule/early finish),
     * we give priority to non default rules.
     */
    return nonDefaultRules.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))[0];
  }
  const defaultRules = ruleset.filter(({ description }) => description.includes('default'));
  return defaultRules.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))[0] || { closed: true };
};

export const attachRule = (date, rule) => {
  const dateKeys = {
    YYYY: moment(date).format('YYYY'),
    M: moment(date).format('M'),
    D: moment(date).format('D'),
    d: moment(date).format('d'),
    h: moment(date).format('H'),
  };

  const yearCheck = dateKeys.YYYY >= rule.year.start && dateKeys.YYYY <= rule.year.end;
  const monthCheck = dateKeys.M >= rule.month.start && dateKeys.M <= rule.month.end;
  const dayOfMonthCheck = dateKeys.D >= rule.dayOfMonth.start && dateKeys.D <= rule.dayOfMonth.end;
  const dayOfWeekCheck = dateKeys.d >= rule.dayOfWeek.start && dateKeys.d <= rule.dayOfWeek.end;

  const relevantIntervals = () => {
    const properties = Object.entries(rule);
    const filtered = properties.filter(([, value]) => get(value, 'start', null) !== null);
    return Object.fromEntries(filtered);
  };

  const ruleToAttach = {
    ruleId: rule.ruleId,
    createdAt: rule.createdAt,
    available: rule.additive,
    additive: rule.additive,
    startTime: rule.hour.start,
    endTime: rule.hour.end,
    ...rule.metadata,
    description: rule.description,
  };

  // Check if current date matches the rule, one interval (year->month->etc) at a time
  // If the interval isn't relevant, we let it through anyway (e.g. wilcard rule for with empty years value)
  if (yearCheck || !relevantIntervals().year) {
    if (monthCheck || !relevantIntervals().month) {
      if (
        (dayOfMonthCheck && relevantIntervals().dayOfMonth) ||
        (dayOfWeekCheck && relevantIntervals().dayOfWeek)
      )
        return ruleToAttach;
    }
  }
};
